/**
 * 通过sso跳转后获取token
 */
import store from '@/store/store';
import * as types from '@/store/types';
import globaljs from '@/utils';
class GetToken {
    constructor () {
        this.store = store;
    }
    /**
     * 登录后获取token
     */
    getToken () {
        const token = this.getUrlParam('token');
        if (token !== null) {
            localStorage.token = token;
            this.store.commit(types.LOGIN, token);
            window.location.href = '//' + window.location.host + "/";
            sessionStorage.userId = token;
        }
    }
    /**
     * 获取URL上的参数
     * @param {String} name 获取URL上的参数；
     */
    getUrlParam (name) {
        const reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); // 构造一个含有目标参数的正则表达式对象
        const r = window.location.search.substr(1).match(reg); // 匹配目标参数
        if (r != null) return unescape(r[2]); return null; // 返回参数值
    }
    // 去登陆
    login () {
        window.location.href = 'http://localhost:8080/'
    }
    // 去注册
    registration () {
        window.location.href = 'http://localhost:8080/register'
    }
};
export default GetToken;



// WEBPACK FOOTER //
// ./src/host/getToken.js